import { TYPES } from "../actions";

const initialState = {
  etsyShops: []
};

export const etsyShopReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_ETSY_SHOPS_SUCCESS:
      return { ...state, 
        etsyShops: action.payload.data
      };

    case TYPES.ACTION_GET_ETSY_SHOPS_FAIL:
      return { ...state, etsyShops: [] };
      
    default:
      return state;
  }
};
